enum TipoMensagemEnum {
  Texto = 'Texto',
  Documento = 'Documento',
}

export default TipoMensagemEnum
